//Dropzone component for receipt upload step. Appears in a modal.
import React from "react"
import { useDropzone } from "react-dropzone"



const ReceiptDropzoneButton = ({ setUploadErrors, onUpload, onError, className="btn", label="Upload Receipt", disabled=undefined }) => {


  const {  fileRejections, isDragActive, isDragAccept, isDragReject, getRootProps, getInputProps } = useDropzone({
    maxFiles: 4,
    accept: "image/*",
    multiple: true,
    minSize: 1024,
    maxSize: 10 * 1024 * 1024, // 10mb(!!)
    onDrop: function(files) {
      console.log(fileRejections.map(file => file.errors[0].message).join(", "))
      if (fileRejections.length > 0) {

        setUploadErrors(`Error uploading: ${fileRejections.map(file => file.errors[0].message).join(", ")}`)
      }
      else {
        onUpload(files)
      }
    }
    
  })

  //Error handling for dropzone - verify that the file is an image or pdf/smaller than 10mb
  const fileRejectionItems = () => {
    const maxErrors = 3
    let maxErrorArray = fileRejections.slice(0, maxErrors)
    maxErrorArray.map(({ file, errors, i }) => {
    
    let msg = "Error with file uploaded"
    try {
      msg = errors
        .map(function (err) {
          let errmessage = err.message
          if (err.code.indexOf("invalid-type") > -1) {
            errmessage = "File must be an image or PDF."
          } else if (err.message.indexOf("larger") > -1) {
            errmessage = "File must be smaller than 10mb."
          }
          else {
            errmessage = "Error with file uploaded"
          }
          return errmessage
        })
        .join(" ")
    } catch (e) {
      console.log(e)
    }
    return msg
  })
}

  return (
    <div className={`receipt-upload-button`}>

        <div {...getRootProps({ className: `dropzone ` })}>
          <input {...getInputProps()} />
          <button className={`${className}`} disabled={disabled}>
          
            <span>{label}</span>
          </button>
          </div>
    </div>
  )
}



export default ReceiptDropzoneButton
